import { ChevronDownIcon } from '@heroicons/react/16/solid';
import React, { ChangeEventHandler } from 'react';

type Option = {
  value: string;
  label: string;
};

type InputProps = {
  name: string;
  label: string;
  defaultValue?: string;
  options: Option[];
  value?: string;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  className?: string;
  width?: string;
  required?: boolean;
};

export const Select = React.forwardRef<HTMLSelectElement, InputProps>(
  (
    {
      name,
      label,
      defaultValue,
      options,
      onChange,
      value,
      className,
      width,
      required,
    },
    ref,
  ) => {
    return (
      <div className={`${width || 'w-full'} max-w-1/2`}>
        <label
          htmlFor={name}
          className="block text-sm/6 font-medium text-gray-900"
        >
          {label}
        </label>
        <div className="mt-2 grid grid-cols-1">
          <select
            id={name}
            name={name}
            value={value}
            aria-label={label}
            defaultValue={defaultValue}
            onChange={onChange}
            ref={ref}
            className={`col-start-1 row-start-1 w-full appearance-none rounded-md bg-white py-2 pl-3 pr-8 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 ${className}`}
            required={required}
          >
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <ChevronDownIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
          />
        </div>
      </div>
    );
  },
);

Select.displayName = 'Select';
